module.exports = __webpack_public_path__ + "static/media/YM65_1.41b116bb.jpg";